<template>
  <v-list-item class="flex-grow-0 item px-0">
    <v-list-item-content>
      <v-list-item-title class="headline">{{ header }}</v-list-item-title>
      <div class="d-flex flex-direction-column">
        <p>
          <span class="display-1 mr-2">{{ stat }}</span>
          <span class="subTitle">{{ subHead }}</span>
        </p>
      </div>
    </v-list-item-content>
  </v-list-item>
</template>

<script>
export default {
  name: "CareerStats",
  props: ["stat", "header", "subHead"]
};
</script>

<style lang="scss" scoped>
.item {
  flex: auto !important;
  width: 25% !important;
}
</style>